import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { boolean } from 'yup';
import { deleveryLocTypeList, extensionTypeList, getExtensionRequest, getOBLDetails, getOBLForOverStay, populateExtensionRequest, returnLocTypeList } from '../../../dashboard/actions/instruction';
import { Item } from 'react-bootstrap/lib/Breadcrumb';

export interface overstayExtensionDetails {
  needExtensionFor: string;
  plannedPickupDate?: Date | null;
  containerReturnDate?: Date | null;
  userRemark?: string;
  status: string;
  rejectRemarks: string;
  extensionRequestId: number | null;
  customerCode?: string | null;
  customerEmailId?: string | null;

}

export interface overstayExtensionTable {
  id: number | null;
  needExtensionFor: string;
  plannedPickupDate?: Date | null;
  containerReturnDate?: Date | null;
  containerNo: string;
  deliveryLocationType: string;
  returnLocation: string;
  currency: string;


}

export interface Isnooze {
  data: Array<overstayExtensionTable>;
  overstayExtension: overstayExtensionDetails;
  extensionTypeOptions: any[];
  deleveryTypeLocation: any[];
  returnTypeLocation: any[],

  localstorage: boolean;
  //containerList:any[]
  // dataLoading: boolean;

}


const initialState: Isnooze = {
  data: [],
  localstorage: false,
  //  dataLoading: true,
  overstayExtension: {
    needExtensionFor: "0",
    plannedPickupDate: null,
    containerReturnDate: null,
    userRemark: '',
    status: '',

    rejectRemarks: '',
    extensionRequestId: null,
    customerCode: ''

  },
  extensionTypeOptions: [],
  deleveryTypeLocation: [],
  returnTypeLocation: [],

  //containerList:[]



};

const safeDate = (value: any): Date | null => {
  if (!value) return null; 
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d; 
};


export const overstayExtensionSlice = createSlice({
  name: 'overstayExtension',
  initialState,
  reducers: {
    clearData: (state) => {
      state.overstayExtension = {
        needExtensionFor: '0',
        plannedPickupDate: null,
        containerReturnDate: null,

        userRemark: '',
        status: '',
        rejectRemarks: '',
        extensionRequestId: null,
        customerCode: ''

      }
      state.data = []

    },
    updateSelectedneedExtensionFor: (state, action: PayloadAction<any>) => {
      state.data.forEach((Item) => { Item.needExtensionFor = action.payload ?? '0' })

    },
    updateSelectedDeleveryLocType: (state, action: PayloadAction<any>) => {
      state.data.forEach((Item) => {
        Item.deliveryLocationType = action.payload
      })
    },
    updateSelectedReturnLocType: (state, action: PayloadAction<any>) => {
      state.data.forEach((Item) => {
        Item.returnLocation = action.payload
      })
    },
    updateSelectedCcy: (state, action: PayloadAction<any>) => {
      state.data.forEach((Item) => { Item.currency = action.payload })
    },
    updateSelectedPlannedPickupDate: (state, action: PayloadAction<any>) => {
      state.data.forEach((Item) => { Item.plannedPickupDate = action.payload })
    },
    updateSelectedContainerReturnDate: (state, action: PayloadAction<any>) => {
      state.data.forEach((Item) => { Item.containerReturnDate = action.payload })
    },
    updateNavigateFlag: (state, action: PayloadAction<any>) => {
      state.localstorage = action.payload
    },
    updateSelectedContainerNo: (state, action: PayloadAction<any>) => {
      const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
      console.log("hereddaa", state.data)
      if (!row) return
      row.needExtensionFor = action.payload.needExtensionFor ?? '0'
      if (action.payload.needExtensionFor != '1004') row.deliveryLocationType = '0'

    },
    updateSelectedDeleveryLocTypeOnContainer: (state, action: PayloadAction<any>) => {
      const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
      if (!row) return
      row.deliveryLocationType = action.payload.deliveryLocationType

    },
    updateSelectedReturnLocTypeOnContainer: (state, action: PayloadAction<any>) => {
      const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
      if (!row) return
      row.returnLocation = action.payload.returnLocation

    },
    updateSelectedCCyOnContainer: (state, action: PayloadAction<any>) => {
      const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
      if (!row) return
      row.currency = action.payload.currency
    },
    updateSelectedPickupDate: (state, action: PayloadAction<any>) => {
      const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
      if (!row) return
      row.plannedPickupDate = action.payload.plannedPickupDate
    },

    updateSelectedReturnDate: (state, action: PayloadAction<any>) => {
      const row = state.data.find((Item) => Item.containerNo == action.payload.containerNo)
      if (!row) return
      row.containerReturnDate = action.payload.containerReturnDate
    },

    clearTableInputValues: (state) => {
      state.data.forEach((item) => {
        item.needExtensionFor = '0'
        item.plannedPickupDate = null
        item.containerReturnDate = null

        item.currency = ''
        item.deliveryLocationType = '0'
        item.returnLocation = '0'

      })
    },
    setContainerData: (state, action: PayloadAction<overstayExtensionTable[]>) => {
      state.data = action.payload;
      console.log("dffdd", state.data)
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getExtensionRequest.pending, (state, action) => {
      // state.dataLoading = true;
      state.overstayExtension = {
        needExtensionFor: '0',
        plannedPickupDate: null,
        containerReturnDate: null,

        userRemark: '',
        status: '',
        rejectRemarks: '',
        extensionRequestId: null,
        customerCode: ''
      }
      state.data = []

    });

    builder.addCase(getExtensionRequest.fulfilled, (state, action) => {
      state.overstayExtension.status = action?.payload?.data?.status
      state.overstayExtension.rejectRemarks = action?.payload?.data?.remarks
      state.overstayExtension.userRemark = action?.payload?.data?.userRemarks
      state.overstayExtension.extensionRequestId = action?.payload?.data?.extensionRequestId
      state.overstayExtension.customerCode = action?.payload?.data?.customerCode
      state.overstayExtension.customerEmailId = action?.payload?.data?.customerEmailId
      state.data = []

      action.payload.data?.containerDetails?.forEach?.((item: any) => {
        console.log(item.pickupLocation,'<<deliveryLocationType')
        state.data.push({
          id: item.containerPickupId,
          needExtensionFor: item.pickupLocation ?? 0,
          plannedPickupDate: safeDate(item.pickupDate),
          containerReturnDate: safeDate(item.containerReturnDate),
          deliveryLocationType: item.deliveryLocationType ?? 0,
          returnLocation: item.returnLocation ?? 0,
          containerNo: item.cntNo,
          currency: item.currency ?? ''
        })
      })

    });

    builder.addCase(populateExtensionRequest.fulfilled, (state, action) => {
      state.overstayExtension.status = action?.payload?.data?.status
      state.overstayExtension.rejectRemarks = action?.payload?.data?.remarks
      state.overstayExtension.userRemark = action?.payload?.data?.userRemarks
      state.overstayExtension.extensionRequestId = action?.payload?.data?.extensionRequestId
      state.overstayExtension.customerCode = action?.payload?.data?.customerCode
      state.overstayExtension.customerEmailId = action?.payload?.data?.customerEmailId

      action.payload.data?.containerDetails?.forEach?.((item: any) => {
        const row = state.data.find((i) => item.cntNo == i.containerNo)
        if (!row) { return }

        row.needExtensionFor = item.pickupLocation ?? 0
        row.plannedPickupDate = safeDate(item.pickupDate)
        row.containerReturnDate = safeDate(item.containerReturnDate)

        row.deliveryLocationType = item.deliveryLocationType ?? 0
        row.returnLocation = item.returnLocation ?? 0
        row.currency = item.currency ?? ''
      })

    });

    builder.addCase(extensionTypeList.fulfilled, (state, action) => {
      state.extensionTypeOptions = action.payload;

    })
    builder.addCase(deleveryLocTypeList.fulfilled, (state, action) => {
      state.data.forEach((Item) => {
        if (!Item.deliveryLocationType || Item.deliveryLocationType === '0') {
        Item.deliveryLocationType = action.payload?.[0]?.value ?? ""
        }
      })
      state.deleveryTypeLocation = action.payload
    })

    builder.addCase(returnLocTypeList.fulfilled, (state, action) => {
      state.data.forEach((Item) => {
         if (!Item.returnLocation || Item.returnLocation === '0') {
        Item.returnLocation = action.payload?.[0]?.value ?? ""
         }
      })
      state.returnTypeLocation = action.payload
    })

    builder.addCase(getOBLForOverStay.fulfilled, (state, action) => {
      const containerList = action.payload.containerList.map(
        (i: any) =>
        ({
          containerNo: i.containerNo,
          needExtensionFor: 0,
          plannedPickupDate: null,
          containerReturnDate: null,
          returnLocation: 0,
          deliveryLocationType: 0,
          currency: ''
        }));
      state.data.forEach((i) => {
        const row: overstayExtensionTable | null = containerList.find((x: overstayExtensionTable) => i.containerNo === x.containerNo)
        if (!row) return
        row.id = i.id ?? null
        row.needExtensionFor = i.needExtensionFor ?? '0'
        row.plannedPickupDate = i.plannedPickupDate
        row.containerReturnDate = i.containerReturnDate
        row.returnLocation = i.returnLocation

        row.deliveryLocationType = i.deliveryLocationType
        row.currency = i.currency
      })

      state.data = containerList
    })
  }
});


export const { clearData, updateSelectedneedExtensionFor, updateNavigateFlag, updateSelectedContainerNo, updateSelectedPickupDate,updateSelectedReturnDate, updateSelectedPlannedPickupDate,updateSelectedContainerReturnDate, updateSelectedDeleveryLocTypeOnContainer, updateSelectedDeleveryLocType,updateSelectedReturnLocType,updateSelectedReturnLocTypeOnContainer,clearTableInputValues, updateSelectedCCyOnContainer, updateSelectedCcy, setContainerData } = overstayExtensionSlice.actions;
export default overstayExtensionSlice.reducer;
